import { Field } from 'formik'
import { Checkbox as _Checkbox } from 'formik-material-ui'
import React from 'react'

const Checkbox = (props) => {
  return <Field component={_Checkbox} {...props} />
}

export { Checkbox }
